import React from 'react';
import {useDeviceManager} from '../hooks/DeviceManagerHook';

import ReceptionTerminal from "../views/ReceptionTerminal";
import RegisterPlayers from "../views/RegisterPlayers";
import LeaderBoard from "../views/LeaderBoard";
import MobileTerminal from '../views/MobileTerminal';
import KioskTerminal from "../views/KioskTerminal";
import DeviceIdentification from "../views/DeviceIdentification";
import ViewRendererDebug from "./debug/ViewRendererDebug";

const VIEW_COMPONENTS = {
    'device-identifier': DeviceIdentification,
    'default': DeviceIdentification,
    'leaderboard': LeaderBoard,
    'mobile': MobileTerminal,
    'kiosk': KioskTerminal,
    'reception': ReceptionTerminal,
    'register-players': RegisterPlayers,
};

const ViewRenderer = ({
                          gameState = {},
                          api,
                          queryParams = {},
                          connectionStatus,
                          showToast,
                          showSuccess,
                          showError,
                          showWarning,
                          showInfo
                      }) => {
    const {fingerprint, viewName, loading, error, refreshView, viewId} = useDeviceManager();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column'
            }}>
                <div style={{marginBottom: '20px'}}>🔍 Identyfikowanie urządzenia...</div>
                {viewId && (
                    <div style={{fontSize: '14px', color: '#666'}}>
                        ViewID: {viewId}
                    </div>
                )}
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                padding: '20px',
                textAlign: 'center',
                color: 'red'
            }}>
                <h2>❌ Błąd inicjalizacji</h2>
                <p>{error}</p>
                <button onClick={refreshView} style={{
                    padding: '10px 20px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                }}>
                    Spróbuj ponownie
                </button>
            </div>
        );
    }

    const ViewComponent = VIEW_COMPONENTS[viewName] || DeviceIdentification;

    const commonProps = {
        fingerprint,
        viewName,
        viewId,
        availableAvatars: gameState.availableAvatars || [],
        players: gameState.players || [],
        holes: gameState.holes || [],
        queryParams,
        api,
        showToast,
        showSuccess,
        showError,
        showWarning,
        showInfo,
        gameState
    };

    return (
        <div style={{ height: '100vh', width: '100vw' }}>
            <ViewRendererDebug
                fingerprint={fingerprint}
                viewName={viewName}
                viewId={viewId}
                connectionStatus={connectionStatus}
                refreshView={refreshView}
            />

            <ViewComponent {...commonProps} />
        </div>
    );
};

export default ViewRenderer;